function getClipTimestamp(clip) {
	return clip?.tag?.timestamp ?? clip?.timestamp ?? 0;
}

function sortClipsChronologically(clips) {
	return [...clips].sort((clipA, clipB) => {
		const timestampDifference = getClipTimestamp(clipA) - getClipTimestamp(clipB);

		if (timestampDifference !== 0) {
			return timestampDifference;
		}

		return (clipA?.id ?? 0) - (clipB?.id ?? 0);
	});
}

const highlightTool = {
	namespaced: true,
	state:      () => {
		return {
			selectedClips:                [],
			highlightIqSelectedClips:     [],
			currentClipIndex:             0,
			selectedAutoHighlightFormula: null,
		};
	},
	mutations: {
		updateSelectedClips(state, clips) {
			const currentClipId = state.selectedClips[state.currentClipIndex]?.id ?? null;
			const sortedClips = sortClipsChronologically(clips);

			state.selectedClips = sortedClips;

			if (sortedClips.length === 0) {
				state.currentClipIndex = 0;
				return;
			}

			if (currentClipId !== null) {
				const currentClipIndex = sortedClips.findIndex((clip) => clip.id === currentClipId);

				if (currentClipIndex !== -1) {
					state.currentClipIndex = currentClipIndex;
					return;
				}
			}

			if (state.currentClipIndex >= sortedClips.length) {
				state.currentClipIndex = Math.max(0, sortedClips.length - 1);
			}
		},
		updateHighlightIqSelectedClips(state, clips) {
			state.highlightIqSelectedClips = clips;
		},
		updateCurrentClipIndex(state, index) {
			state.currentClipIndex = index;
		},
		setSelectedAutoHighlightFormula(state, formula) {
			state.selectedAutoHighlightFormula = formula;
		},
	},
	getters: {
		selectedClips:            (state) => state.selectedClips,
		highlightIqSelectedClips: (state) => state.highlightIqSelectedClips,
		currentClipIndex:         (state) => state.currentClipIndex,
		currentClip:              (state) => {
			return state.selectedClips[state.currentClipIndex];
		},
		selectedAutoHighlightFormula: (state) => state.selectedAutoHighlightFormula,
	},
	actions: {
		updateSelectedClips({ commit }, clips) {
			commit('updateSelectedClips', clips);
		},
		updateHighlightIqSelectedClips({ commit }, clips) {
			commit('updateHighlightIqSelectedClips', clips);
		},
		nextClip({ commit, state }) {
			if (state.currentClipIndex < state.selectedClips.length - 1) {
				commit('updateCurrentClipIndex', state.currentClipIndex + 1);
			}
		},
		prevClip({ commit, state }) {
			if (state.currentClipIndex > 0) {
				commit('updateCurrentClipIndex', state.currentClipIndex - 1);
			}
		},
		goToClip({ commit, state }, clip) {
			const index = state.selectedClips.findIndex((c) => c.id === clip.id);
			commit('updateCurrentClipIndex', index);
		},
		setSelectedAutoHighlightFormula({ commit }, formula) {
			commit('setSelectedAutoHighlightFormula', formula);
		},
	},
};

export default highlightTool;
